import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    ValidationInput,
    CreateChancel,
    MaskInput,
    SelectTypeAutocomplete,
    CheckboxesTags,
    DateTypeSelect,
    SelectAutocompletePagination,
    ModalsTabs,
} from 'components';
import {
    EmailValidator,
    ErrorText,
    FindErrorItem,
    FindLoad,
    FindSuccessItem,
    getPhoneErrorText,
    hooksForErrors,
    isNotEmpty,
    languagesById,
    renderStaffName,
    staffStatusEnums,
    useModal,
} from 'utils';
import { clientActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, systemActions } from 'store';
import moment from 'moment/moment';
import { Checkbox } from '@mui/material';

const list = [
    { name: 'Male', id: 'MALE' },
    { name: 'Female', id: 'FEMALE' },
    { name: 'Other', id: 'OTHER' },
];

export const CreateClient = () => {
    const ACTION_TYPE = 'CREATE_CLIENT';
    const [error, setError] = useState('');
    const [errorOriginal, setErrorOriginal] = useState('');
    const [inputs, setInputs] = useState({});
    const [step, setStep] = useState('first');
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);
    const companies = useSelector((state) => state.system.companies);
    const phoneErrorMsg = getPhoneErrorText(inputs.phoneNumber);
    const emailErrorMsg = !EmailValidator.test(inputs.email) ? ErrorText.emailValid : '';
    const phoneErrorText = hooksForErrors.getPhoneError(error, backError, phoneErrorMsg);
    const secondaryPhoneErrorText = hooksForErrors.getPhoneError(error, backError, phoneErrorMsg);
    const emailErrorText = hooksForErrors.getEmailError(error, backError, emailErrorMsg);
    const { close } = useModal();

    useEffect(() => {
        if (companies?.length && !inputs?.company) {
            const defaultCompany = companies?.find((i) => i?.isDefault);
            if (defaultCompany) {
                setInputs((prevState) => ({ ...prevState, company: defaultCompany?.id }));
            }
        }
    }, [companies]);

    useEffect(() => {
        dispatch(systemActions.getCompanies());
    }, []);

    useEffect(() => {
        if (success?.type === ACTION_TYPE) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
        if (backError && phoneErrorText && step === 'second') {
            setStep('first');
            setError(phoneErrorText);
            setErrorOriginal(backError?.error?.[0]);
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        }
        if (backError && secondaryPhoneErrorText && step === 'second') {
            setStep('first');
            setError(secondaryPhoneErrorText);
            setErrorOriginal(backError?.error?.[0]);
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        }
        if (backError?.error === 'User already exists in another organization.' && step === 'second') {
            setStep('first');
            // setError(backError?.error);
        }
        if (backError?.error === 'This email is already in use.' && step === 'second') {
            setStep('first');
            // setError(backError?.error);
        }
    }, [success, backError]);

    const handleChange = (e) => {
        setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        error === e.target.name && setError('');
    };

    const handleChangeLanguages = (e) => {
        setInputs((prevState) => ({ ...prevState, ['languages']: e }));
    };

    const handleCreate = () => {
        if (step === 'first') {
            const emailIsValid = inputs?.inviteToPortal
                ? isNotEmpty(inputs.email) && EmailValidator.test(inputs.email)
                : inputs.email
                ? EmailValidator.test(inputs.email)
                : true;
            // const firstStepIsValid = isNotEmpty(inputs.firstName) && isNotEmpty(inputs.lastName) && inputs?.company && emailIsValid;
            const firstStepIsValid = isNotEmpty(inputs.firstName) && isNotEmpty(inputs.lastName) && emailIsValid;

            if (firstStepIsValid) {
                setStep('second');
                setError('');
            } else {
                const firstStepErrorText = !isNotEmpty(inputs.firstName)
                    ? 'firstName'
                    : !isNotEmpty(inputs.lastName)
                    ? 'lastName'
                    : inputs?.inviteToPortal && !isNotEmpty(inputs.email)
                    ? 'email'
                    : // !isNotEmpty(inputs.company) ? 'company' :
                    !emailIsValid
                    ? emailErrorMsg
                    : '';
                setError(firstStepErrorText);
            }
        } else if (step === 'second') {
            const data = {
                firstName: inputs.firstName,
                middleName: inputs?.middleName ? inputs.middleName : null,
                lastName: inputs.lastName,
                birthday: inputs?.birthday,
                registrationDate: inputs?.registrationDate,
                status: 'ACTIVE',
            };
            inputs?.languages?.length ? (data.languages = inputs?.languages?.map((i) => i?.id)) : delete data.languages;
            data.phoneNumber = inputs?.phoneNumber ? parseInt(inputs?.phoneNumber.replace(/[^0-9]/g, '')) + '' : null;
            data.phoneSecondary = inputs?.phoneSecondary ? parseInt(inputs?.phoneSecondary.replace(/[^0-9]/g, '')) + '' : null;
            data.ethnicity = inputs?.ethnicity ? inputs?.ethnicity : null;
            data.familyLanguage = inputs?.familyLanguage ? inputs?.familyLanguage : null;
            data.email = inputs?.email ? inputs?.email : null;
            data.renderingProvider = inputs?.renderingProvider ? inputs?.renderingProvider : null;
            data.supervisingProvider = inputs?.supervisingProvider ? inputs?.supervisingProvider : null;
            inputs.gender ? (data.gender = inputs.gender) : delete data.gender;
            inputs.caseManager ? (data.caseManager = inputs.caseManager) : delete data.caseManager;
            inputs.branchNumber ? (data.branchNumber = inputs.branchNumber) : delete data.branchNumber;
            // inputs.company ? data.company = inputs.company : delete data.company;
            dispatch(clientActions.createClient(data));
        }
    };

    return (
        <div style={{ width: 463 }}>
            <p style={{ textAlign: 'center' }} className="modal-header-title">
                Add Client
            </p>
            {step && <ModalsTabs steps={step} setStep={setStep} />}
            <div className="modal-body-wrapper">
                {step === 'first' ? (
                    <div>
                        <ValidationInput
                            variant={'outlined'}
                            onChange={handleChange}
                            value={inputs.firstName}
                            type={'text'}
                            label={'First Name*'}
                            name="firstName"
                            typeError={error === 'firstName' ? `First name ${ErrorText.isRequired}` : ''}
                            Length={25}
                        />
                        <ValidationInput
                            variant={'outlined'}
                            onChange={handleChange}
                            value={inputs.middleName}
                            type={'text'}
                            label={'Middle Name'}
                            name="middleName"
                            typeError={error === 'middleName' ? ErrorText.field : ''}
                            Length={25}
                        />
                        <ValidationInput
                            variant={'outlined'}
                            onChange={handleChange}
                            value={inputs.lastName}
                            type={'text'}
                            label={'Last Name*'}
                            name="lastName"
                            typeError={error === 'lastName' ? `Last name ${ErrorText.isRequired}` : ''}
                            Length={25}
                        />
                        <ValidationInput
                            validator={EmailValidator}
                            variant={'outlined'}
                            name={'email'}
                            type={'email'}
                            label={'Email Address'}
                            typeError={emailErrorText}
                            value={inputs?.email}
                            onChange={handleChange}
                        />
                        <MaskInput
                            name="phoneNumber"
                            label="Phone Number"
                            value={inputs.phoneNumber}
                            handleChange={handleChange}
                            error={errorOriginal === 'phoneNumber must be a valid phone number' && phoneErrorText}
                        />
                        <MaskInput
                            name="phoneSecondary"
                            label="Secondary Phone Number"
                            value={inputs.phoneSecondary}
                            handleChange={handleChange}
                            error={errorOriginal === 'phoneSecondary must be a valid phone number' && secondaryPhoneErrorText}
                        />
                        <SelectTypeAutocomplete
                            title={'Home Office'}
                            name={'company'}
                            handleSelect={handleChange}
                            defaultValue={inputs?.company}
                            list={companies || []}
                            renderValue={(i) => i?.name}
                            // error={error}
                            // typeError={error === 'company' ? ErrorText.selectField : ''}
                        />
                        <SelectAutocompletePagination
                            defaultStatuses={[staffStatusEnums.ACTIVE]}
                            title={'Rendering Provider'}
                            name={'renderingProvider'}
                            handleSelect={handleChange}
                            defaultValue={inputs?.renderingProvider}
                            renderValue={(i) => renderStaffName(i)}
                            type={'staff'}
                        />
                        <SelectAutocompletePagination
                            defaultStatuses={[staffStatusEnums.ACTIVE]}
                            title={'Supervising Provider'}
                            name={'supervisingProvider'}
                            handleSelect={handleChange}
                            defaultValue={inputs?.supervisingProvider}
                            renderValue={(i) => renderStaffName(i)}
                            type={'staff'}
                        />
                        {/*<div className="flex-align-center" style={{ gap: 8, margin: '12px 0 32px' }}>*/}
                        {/*    <Checkbox*/}
                        {/*        onClick={(e) => {*/}
                        {/*            handleChange({*/}
                        {/*                target: {*/}
                        {/*                    name: 'inviteToPortal',*/}
                        {/*                    value: !inputs?.inviteToPortal,*/}
                        {/*                },*/}
                        {/*            });*/}
                        {/*            if (error === 'email') {*/}
                        {/*                setError('');*/}
                        {/*            }*/}
                        {/*        }}*/}
                        {/*        name={'inviteToPortal'}*/}
                        {/*        style={{*/}
                        {/*            padding: 0,*/}
                        {/*            color: inputs?.inviteToPortal ? '#347AF0' : '#D0D5DD',*/}
                        {/*        }}*/}
                        {/*        checked={inputs?.inviteToPortal}*/}
                        {/*    />*/}
                        {/*    <p className="no-prior-auth">Invite Client to Portal</p>*/}
                        {/*</div>*/}
                    </div>
                ) : (
                    <div>
                        <SelectTypeAutocomplete
                            title={'Gender'}
                            name={'gender'}
                            handleSelect={handleChange}
                            defaultValue={inputs?.gender}
                            list={list}
                            error={error}
                            typeError={error === 'gender' ? ErrorText.selectField : ''}
                            renderValue={(i) => i?.name}
                        />
                        <DateTypeSelect
                            type={'modalInput'}
                            name={'birthday'}
                            outLabel={'Date of Birth'}
                            handleGetDates={handleChange}
                            values={inputs}
                            max={moment.utc().format('YYYY-MM-DD')}
                        />
                        <ValidationInput
                            variant={'outlined'}
                            onChange={handleChange}
                            value={inputs.ethnicity}
                            label={'Ethnicity'}
                            name="ethnicity"
                            typeError={error === 'ethnicity' ? ErrorText.field : ''}
                        />
                        <CheckboxesTags
                            name="languages"
                            handleChange={handleChangeLanguages}
                            renderValue={(i) => i?.label}
                            value={inputs?.languages || []}
                            permissionsList={languagesById || []}
                            label={'Language'}
                            uiType={'modalCheckboxSelect'}
                        />
                        <SelectTypeAutocomplete
                            title={'Family Language'}
                            name={'familyLanguage'}
                            handleSelect={handleChange}
                            defaultValue={inputs?.familyLanguage}
                            list={languagesById || []}
                            error={error}
                            renderValue={(i) => i?.label}
                        />
                        <DateTypeSelect
                            type={'modalInput'}
                            name={'registrationDate'}
                            outLabel={'Intake Date'}
                            handleGetDates={handleChange}
                            values={inputs}
                        />
                        <ValidationInput
                            variant={'outlined'}
                            onChange={handleChange}
                            value={inputs?.caseManager}
                            label={'Case Manager'}
                            name="caseManager"
                        />
                        <ValidationInput
                            variant={'outlined'}
                            onChange={handleChange}
                            value={inputs?.branchNumber}
                            label={'Branch Number'}
                            name="branchNumber"
                        />
                    </div>
                )}
            </div>
            <CreateChancel
                loader={!!loader.length}
                create={step === 'first' ? 'Next' : 'Add'}
                chancel={'Cancel'}
                onCreate={handleCreate}
                onClose={close}
                buttonWidth="224px"
            />
        </div>
    );
};
